<uda-select of="portTypes"
            name="typeId"
            {update-for}="dataModel.customerId"
            update-function="filterByCustomerId"
            create-function="createForCustomer"
            col="6 12"
            {update-for}="dataModel.customerId"
            update-function="filterByCustomerId"
            item-none="true"></uda-select>
